import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./steps.css";

const StepsSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
    AOS.refresh();
  }, []);

  return (
    <div className="steps-container">
      <div className="steps-content">
        <div className="steps-header" data-aos="fade-up">
          <h1 className="steps-title">
            <span className="relative-span">
              <span className="relative-text">
                Acompanhamos-te
              </span>
            </span>
            em todas as etapas
          </h1>
        </div>

        <div className="steps-cards"
          data-aos="fade-up"
          data-aos-delay="400" >

          {/* Step 1 */}
          <div className="step-card step-1">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" className="step-icon">
                <g opacity="0.2"><path d="M216,64V192H128V64Z"></path></g>
                <path d="M224,128a8,8,0,0,1-8,8H128a8,8,0,0,1,0-16h88A8,8,0,0,1,224,128ZM128,72h88a8,8,0,0,0,0-16H128a8,8,0,0,0,0,16Zm88,112H128a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16ZM82.34,42.34,56,68.69,45.66,58.34A8,8,0,0,0,34.34,69.66l16,16a8,8,0,0,0,11.32,0l32-32A8,8,0,0,0,82.34,42.34Zm0,64L56,132.69,45.66,122.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Zm0,64L56,196.69,45.66,186.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z"></path>
              </svg>
            </div>
            <div>
              <h3 className="step-label">Avaliação</h3>
              <p className="step-description">Análise de preços e rentabilidade na tua zona.</p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="step-card step-2">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" className="step-icon">
                <g opacity="0.2"><path d="M192,112a80,80,0,1,1-80-80A80,80,0,0,1,192,112Z"></path></g>
                <path d="M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"></path>
              </svg>
            </div>
            <div>
              <h3 className="step-label">Estudo de mercado</h3>
              <p className="step-description">Avaliação da procura local.</p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="step-card step-3">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" className="step-icon">
                <g opacity="0.2"><path d="M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z"></path></g>
                <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"></path>
              </svg>
            </div>
            <div>
              <h3 className="step-label">Propostas</h3>
              <p className="step-description">Soluções personalizadas para maximizar os teus ganhos.</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default StepsSection;